import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import _isNil from 'lodash/isNil';
import _isEmpty from 'lodash/isEmpty';

import { RootState } from '../store';
import { updateSiteConstant } from '../store/reducer';
import { getValueFromLocalStorage } from '../utils/common';
import Header from '../pages/signin/components/Header';
import { Loader } from '../ui-component';

import { useFetchSiteConstant } from './hook/useFetchSiteConstants';
import { PublicWrapperContent } from './style';

type WrapperProps = {
  Content: () => JSX.Element;
};

const PublicWrapper = ({ Content }: WrapperProps) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const token = getValueFromLocalStorage('token');

  const { commonDataReducer } = useSelector((state: RootState) => state);
  const { currLang } = commonDataReducer;

  const currentLanguageObj = currLang ?? getValueFromLocalStorage('currLang');

  const currentLanguage =
    !_isNil(currentLanguageObj) && !_isEmpty(currentLanguageObj) ? currentLanguageObj.value : 'en';

  const { handleGetSiteConstantsApi, isLoading } = useFetchSiteConstant();

  useEffect(() => {
    if (!_isNil(token) && token !== '') {
      navigate('/dashboard');
    }
  }, [token]);

  useEffect(() => {
    dispatch(updateSiteConstant({ data: {} }));
    void handleGetSiteConstantsApi(currentLanguage);
  }, [currentLanguage]);

  return (
    <>
      {!isLoading && (
        <>
          <Header />
          <PublicWrapperContent>
            <Content />
          </PublicWrapperContent>
        </>
      )}
      <Loader showLoader={isLoading} />
    </>
  );
};

export default PublicWrapper;
